import { apiRequest } from "../../util/apiUtils";


export const faqListData = async (params) => {
  try {
    const res = await apiRequest("get", "common/faqList", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};